import React from 'react';
import { func, string, bool } from 'prop-types';

import styles from './actionBar.module.css';
import { langType, withLang } from '../../../i18n';
import ConfirmButton from '../../ConfirmButton';

const ActionBarButtonComponent = ({
  iconClass, titleKey, onClick, confirm, confirmKey, translate, dataCy
}) => {
  if (confirm && onClick) {
    return (
      <ConfirmButton
        className={`actionButton ${iconClass} ${styles.actionButton}`}
        modalText={translate(confirmKey)}
        onConfirm={onClick}
        title={translate(titleKey)}
        testId={dataCy}
      />
    );
  }
  return (
    <button
      type="button"
      className={`actionButton ${iconClass} ${styles.actionButton}`}
      title={translate(titleKey)}
      onClick={onClick && onClick}
      disabled={!onClick}
      data-cy={dataCy}
    />
  );
};

ActionBarButtonComponent.propTypes = {
  iconClass: string.isRequired,
  titleKey: string.isRequired,
  onClick: func,
  confirm: bool,
  confirmKey: string,
  dataCy: string,
  ...langType
};

ActionBarButtonComponent.defaultProps = {
  onClick: undefined,
  confirm: false,
  confirmKey: undefined,
  dataCy: ''
};

const ActionBarButton = withLang(ActionBarButtonComponent);

const ActionBar = ({
  onEdit, onNewVersion, onCopy, onArchive, archiveTranslationKey, versionable
}) => (
  <div data-cy="actionBar">
    <ActionBarButton
      iconClass="icon--archive"
      titleKey="actions.archive"
      onClick={onArchive}
      confirm
      confirmKey={archiveTranslationKey}
      dataCy="archive-icon-button"
    />
    {versionable && <ActionBarButton iconClass="icon--version-history" titleKey="actions.viewVersionHistory" dataCy="view-versions-icon-button" />}
    {versionable && <ActionBarButton iconClass="icon--new-version" titleKey="actions.createNewVersion" onClick={onNewVersion} dataCy="new-version-icon-button" />}
    <ActionBarButton iconClass="icon--copy" titleKey="actions.createNewCopy" onClick={onCopy} dataCy="copy-icon-button" />
    <ActionBarButton iconClass="icon--edit-event" titleKey="actions.edit" onClick={onEdit} dataCy="edit-icon-button" />
  </div>
);

ActionBar.propTypes = {
  onEdit: func,
  onNewVersion: func,
  onCopy: func,
  onArchive: func,
  archiveTranslationKey: string,
  versionable: bool
};

ActionBar.defaultProps = {
  onEdit: undefined,
  onNewVersion: undefined,
  onCopy: undefined,
  onArchive: undefined,
  archiveTranslationKey: undefined,
  versionable: true
};

export default ActionBar;
